<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 15:55:45
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <h3 class="myTit clearfix">
      <span>我的办件</span>
      <ul class="clearfix noselect">
        <li
          :class="{active:titIndex === 0}"
          @click="titChange(0)"
        >办理中</li>
        <li
          :class="{active:titIndex === 1}"
          @click="titChange(1)"
        >已经办结</li>
      </ul>
    </h3>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="xuhao"
        width="60"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="事项名称"
        prop="guidelineName"
      >
        <template slot-scope="scope">
          <span>{{scope.row.guidelineName}}</span>
          <div
            class="newBg"
            v-if="scope.row.hasNew"
          >新动态</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="processinstancecreatetime"
        label="发起时间"
        width="170"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="当前节点"
        width="150"
        align="center"
        v-if="titIndex == 0"
      >
      </el-table-column>
      <el-table-column
        prop="processinstanceendtime"
        label="办结时间"
        width="170"
        align="center"
        v-if="titIndex == 1"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="lookDetail(scope.$index, scope.row)"
            class="detailBtn"
          >详情</el-button>
          <el-button
            size="mini"
            @click="evaluation(scope.$index, scope.row)"
            class="detailBtn"
            v-if="titIndex == 1 && scope.row.portalPcHandlingGuidelineSuggestion === 1"
          >评价
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="inquiryOpen(scope.$index, scope.row)"
            class="advisoryBtn"
            v-if="scope.row.portalPcHandlingGuidelineConsultation === 1"
          >
            咨询</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block fenyeBox">
      <el-pagination
        @size-change="handleSizeChange0"
        @current-change="handleCurrentChange0"
        :current-page="fenye.currentPage0"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="fenye.pageSize0"
        layout="total, sizes, prev, pager, next, jumper"
        :total="fenye.totalNum0"
        v-if="type == 2"
      >
      </el-pagination>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="fenye.currentPage1"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="fenye.pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="fenye.totalNum1"
        v-if="type == 3"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="我要咨询"
      :visible.sync="inquiryVisible"
      width="550px"
      class="dialog"
    >
      <el-form
        ref="form"
        label-width="90px"
      >
        <el-form-item label="咨询内容：">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入咨询内容"
            v-model="zxText"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="注意事项：">
          <div class="tips">
            <p>注意事项：你可以在个人中心查看你提交的咨询及回复。提交后 的咨询问题无法删除</p>
            <p>
              <!-- <el-checkbox label="我已阅读注意事项" name="type" v-model="checkStatus"></el-checkbox> -->
              <template>
                <!-- `checked` 为 true 或 false -->
                <el-checkbox v-model="checkStatus">我已阅读注意事项</el-checkbox>
              </template>
            </p>
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="zxSubmit()"
          class="tjBtn"
        >提交问题</el-button>
        <el-button @click="inquiryVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="我要评价"
      :visible.sync="inquiryVisible1"
      width="550px"
      class="dialog"
    >

      <el-form
        ref="form"
        label-width="90px"
      >
        <el-form-item label="评星：">
          <div class="block">
            <!-- <span class="demonstration">默认不区分颜色</span> -->
            <div style="padding-top:10px"></div>
            <el-rate
              v-model="score"
              show-text
              :texts="texts"
            ></el-rate>
          </div>
        </el-form-item>
        <el-form-item label="评价内容：">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入评价内容"
            v-model="pjText"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="注意事项：">
          <div class="tips">
            <p>1、评价仅在审核后公开；2、你可以在个人中心查看你提交的评价。</p>
            <p>
              <template>
                <!-- `checked` 为 true 或 false -->
                <el-checkbox v-model="checkStatus1">我已阅读注意事项</el-checkbox>
              </template>
            </p>
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="pjSubmit()"
          class="tjBtn"
        >提交评价</el-button>
        <el-button @click="inquiryVisible1 = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import { request } from "@/api/axios.js";
export default {
  props: {
    numChange: {
      type: Function
    }
  },
  data() {
    return {
      tableData: [],
      titIndex: 0,
      texts: ["非常不满", "不满", "一般", "满意", "非常满意"],
      inquiryVisible: false,
      inquiryVisible1: false,
      textarea: "",
      fenye: {
        currentPage0: 1,
        pageSize0: 10,
        totalNum0: 0,
        currentPage1: 1,
        pageSize1: 10,
        totalNum1: 0
      },
      checkStatus: false,
      checkStatus1: false,
      type: 2,
      zxText: "",
      pjText: "",
      inquiryVisible: false,
      guidelineCode: "",
      score: 5 //评分
    };
  },
  mounted() {
    let userSite1 = localStorage.getItem("userSite1");
    localStorage.setItem("userSite1", "");
    if (userSite1) {
      this.titIndex = parseInt(userSite1);
      this.type = this.titIndex + 2;
    }
    this.getMyItem();
  },
  methods: {
    lookDetail(index, row) {
      request({
        method: "post",
        url: "/portal-ywtb/web/my/editGuidelineinProcessCheck",
        data: {
          id: row[this.titIndex === 0 ? "processDetailId" : "id"],
          zt: this.titIndex === 0 ? "processDetail" : "process"
        }
      })
        .then(res => {
          // 成功
          if (res.status === 200 && res.request === undefined) {
            this.$set(this.tableData[index], "hasNew", false);
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg || "error"
            });
          }
        })
        .catch(err => {
          // 失败
          this.$message({
            type: "warning",
            message: err.msg || "error"
          });
        });

      if (this.titIndex == 0) {
        window.open(row.taskUrl);
      } else if (this.titIndex == 1) {
        window.open(row.processinstanceurl);
      }
    },
    inquiryOpen(index, row) {
      this.guidelineCode = row.handlingguidelinecode;
      this.inquiryVisible = true;
    },
    handleSizeChange0(val) {
      this.fenye.pageSize0 = val;
      // console.log(`每页 ${val} 条`);
      this.getMyItem();
    },
    handleCurrentChange0(val) {
      this.fenye.currentPage0 = val;
      // console.log(`当前页: ${val}`);
      this.getMyItem();
    },
    handleSizeChange1(val) {
      this.fenye.pageSize1 = val;
      // console.log(`每页 ${val} 条`);
      this.getMyItem();
    },
    handleCurrentChange1(val) {
      this.fenye.currentPage1 = val;
      // console.log(`当前页: ${val}`);
      this.getMyItem();
    },
    titChange(idx) {
      this.titIndex = idx;
      if (idx === 0) {
        this.type = 2;
      } else if (idx === 1) {
        this.type = 3;
      }
      this.getMyItem();
    },
    // 我要咨询
    zxSubmit() {
      if (this.zxText == "") {
        this.$message({
          message: "内容不能为空",
          type: "warning"
        });
        return;
      }
      if (!this.checkStatus) {
        this.$message({
          message: "请先阅读注意事项",
          type: "warning"
        });
        return;
      }
      let sendData = qs.stringify({
        content: this.zxText,
        guidelineCode: this.guidelineCode
        // memberId: this.$store.state.userId
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/addConsultation",
        sendData
      ).then(res => {
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.zxText = "";
        setTimeout(() => {
          this.inquiryVisible = false;
        }, 500);
      });
    },
    pjSubmit() {
      if (this.pjText == "") {
        this.$message({
          message: "内容不能为空",
          type: "warning"
        });
        return;
      }
      if (!this.checkStatus1) {
        this.$message({
          message: "请先阅读注意事项",
          type: "warning"
        });
        return;
      }
      let sendData = qs.stringify({
        suggestion: this.pjText,
        guidelineCode: this.guidelineCode,
        satisfaction: this.score,
        memberId: this.$store.state.userId
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guidelineSuggestion/addSuggestion",
        sendData
      ).then(res => {
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.pjText = "";
        setTimeout(() => {
          this.inquiryVisible1 = false;
        }, 500);
      });
    },
    evaluation(index, row) {
      this.guidelineCode = row.handlingguidelinecode;
      this.inquiryVisible1 = true;
    },
    // 获取我的事项
    getMyItem() {
      let sendData;
      if (this.type == 2) {
        sendData = qs.stringify({
          pageNum: this.fenye.currentPage0,
          pageSize: this.fenye.pageSize0,
          processType: this.type,
          memberId: this.$store.state.userId
        });
      } else if (this.type == 3) {
        sendData = qs.stringify({
          pageNum: this.fenye.currentPage1,
          pageSize: this.fenye.pageSize1,
          processType: this.type,
          memberId: this.$store.state.userId
        });
      }
      this.ywtbRequest("/portal-ywtb/web/my/guidelineinProcess", sendData).then(
        res => {
          var data = res.dataList;
          for (let i = 0; i < data.length; i++) {
            if (this.type == 2) {
              this.fenye.totalNum0 = res.count;
            } else if (this.type == 3) {
              this.fenye.totalNum1 = res.count;
            }
            data[i].xuhao = i + 1;
          }
          let list = res.dataList;
          list.map((item, index) => {
            if (this.titIndex === 0) {
              // 办理中
              item.hasNew = item.checkBlz === "0" ? true : false;
            } else if (this.titIndex === 1) {
              // 已办结
              item.hasNew = item.checkYbj === "0" ? true : false;
            }
          });
          this.tableData = list || [];
          this.numChange(res.count);
        }
      );
    }
  }
};
</script>

<style scoped>
.myTit {
  /* line-height: 42px; */
  padding: 30px 0 15px 0;
  font-size: 16px;
  margin-bottom: 10px;
}

.myTit > span {
  float: left;
  color: #091b28;
  font-size: 22px;
  font-family: PingFang SC;
}

.myTit > ul {
  float: right;
}

.myTit > ul > li {
  float: left;
  width: 84px;
  height: 34px;
  background: rgba(53, 139, 247, 0.1);
  color: #687986;
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
}

.myTit > ul > li.active {
  background-color: #358bf7;
  color: #fff;
}

.detailBtn,
.advisoryBtn {
  width: 56px;
  height: 27px;
  border-radius: 14px;
  padding: 0;
  text-align: center;
  font-size: 13px;
  color: #fff;
  border: none;
}

.detailBtn {
  background: rgba(255, 165, 71, 1);
}

.detailBtn:hover, .detailBtn:focus {
  background: rgba(255, 165, 71, 0.8);
  color: #fff;
}

.advisoryBtn {
  background: rgba(53, 139, 247, 1);
}

.advisoryBtn:hover, .advisoryBtn:focus {
  background: rgba(53, 139, 247, 0.8);
  color: #fff;
}

.fenyeBox {
  text-align: center;
  padding-top: 20px;
}

.newBg {
  display: inline-block;
  width: 55px;
  height: 23px;
  line-height: 22px;
  background: url(../../../../static/images/newBg.png) no-repeat 0px 0px;
  text-align: center;
  color: #fff;
  margin-left: 6px;
}

.tips > p {
  color: #999;
  padding-top: 9px;
  line-height: 22px;
  /* height: 22px; */
}
.dialog /deep/ .el-dialog__title {
  color: #262626;
  font-size: 18px;
  font-weight: 700;
}
.dialog /deep/ .el-textarea__inner {
  resize: none;
}
.dialog /deep/ .el-dialog__body {
  padding: 25px 40px 5px 30px;
}
.dialog /deep/ .el-dialog__footer {
  text-align: center;
  padding: 0px 0 30px 0;
}
.dialog /deep/ .el-button {
  border-radius: 2px;
}
.dialog .tjBtn {
  background: rgba(68, 110, 255, 1);
  color: #fff;
  border: none;
}
.dialog .tjBtn:hover {
  background: rgb(50, 93, 250);
}
</style>



// WEBPACK FOOTER //
// src/components/page/user/MyItem.vue